import template from './app.html';

let appComponent = {
  bindings: {},
  template,
};

export default appComponent;



// WEBPACK FOOTER //
// ./src/app/app.component.js